import * as types from './mutation-types'

export default {
    [types.SET_STAKEHOLDERS](state, stakeholders) {
        state.stakeholders = stakeholders
    },
    [types.ADD_STAKEHOLDER](state, data) {
        state.stakeholders = [data.stakeholder, ...state.stakeholders]
    },
   
    [types.UPDATE_STAKEHOLDER] (state, data) {
        let pos = state.stakeholders.findIndex(stakeholder => stakeholder.id === data.stakeholder.id)
        state.stakeholders.splice(pos, 1)
        state.stakeholders = [data.stakeholder, ...state.stakeholders]
    },

}
